import { appointmentReducer as appointment } from './appointment';
import { clientReducer as client } from './client';
import { customerReducer as user } from './customer';
import { treatmentCategoriesReducer as treatmentCategories } from './treatment-categories';
import { brandsReducer as brands } from './brands';
import { appointmentTypesReducer as appointmentTypes } from './appointment-types';
import { bookingsReducer as bookings } from './bookings';
import { journeyStateReducer as journeyState } from './journey-state';
import { shopsReducer as shops } from './shops';
import { apiReducer as api } from './api.reducer';

export { dateSlotsApi, timeSlotsApi } from './slots';
export { serviceApi, serviceUrl } from './service';
export { shopsApi, shopsActions, shopsSelectors } from './shops';
export {
  clientApi,
  clientJSONApi,
  updateClientDetails,
  getClientDetails,
  extractClientDetails,
  loadClientDetails,
} from './client';
export { partnersApi } from './partners';
export { bookingsApi, bookingsSelectors, bookingsActions } from './bookings';
export {
  appointmentTypeApi,
  appointmentTypesApi,
  appointmentTypesActions,
  appointmentTypesSelectors,
} from './appointment-types';
export { api } from './api';
export { treatmentCategoriesActions, treatmentCategoriesApi } from './treatment-categories';
export { treatmentBrandsActions, treatmentBrandsApi } from './treatment-brands';
export {
  appointmentActions,
  appointmentSelectors,
  appointmentDraftActions,
  appointmentDraftHelpers,
  appointmentDraftApi,
  appointmentDraftSelectors,
  appointmentToAppointmentDraftComparisonSelectors,
} from './appointment';
export { journeyStateActions, journeyStateApi, journeyStateSelectors } from './journey-state';
export { getCustomerAnalytics, restoreAnalytics } from './analytics';
export { addressesApi } from './address';
export { locationApi } from './location';
export { fetchCustomer, setCustomer } from './customer';
export { tokenApi } from './token';
export { pageCopyApi } from './page-copy';

export { brandsActions } from './brands';
export { productsActions } from './products';

export { apiSelectors } from './api.selectors';
export { apiActions } from './api.actions';
export { apiHelpers } from './api.helpers';

export const apiReducers = {
  api,
  appointment,
  client,
  user,
  treatmentCategories,
  appointmentTypes,
  brands,
  bookings,
  journeyState,
  shops,
};
